import { Component, OnInit, Input, ChangeDetectionStrategy, output } from "@angular/core";
import { StaticClass } from "../../class/general-classes/static-classes";
import { IonIcon, IonRange } from "@ionic/angular";

@Component({
    selector: "app-draggable-slider",
    templateUrl: "./draggable-slider.component.html",
    styleUrls: ["./draggable-slider.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonIcon, IonRange]
})
export class DraggableSliderComponent implements OnInit {
  //Value to emit
  private _currentValue: number = 0;

  //Actual value to show on slider bar
  public progressValue: string = "0";

  //Unit of measurement to show for progress value (if any)
  @Input() public unit?: string = "";

  //Value for slider initialization
  @Input() public value: number;

  //Lighter color for slider
  @Input() public lighterColor: string;

  //Darker color for slider
  @Input() public darkerColor: string;

  //Array for getting multiple colors for slider
  @Input() public gradientColors: Array<string> = [];

  //Allow drag for slider
  @Input() public allowDrag: boolean;

  //Min and max value for slider (default 0 and 100)
  @Input() public minValue: number = 0;
  @Input() public maxValue: number = 100;

  //Step value for slider (default 5)
  @Input() public numberOfSteps: number = 5;

  @Input() public startIconSrc = "";
  @Input() public endIconSrc = "";

  @Input() public isMinMaxVisible: boolean = true;

  //Event emitter for slider value change
  readonly onSliderValueChanged = output<number>();

  //Event emitter for changing color (of slider or other elements)
  readonly onSliderChangeColor = output<number>();

  public startIconColor: string = "";
  public endIconColor: string = "";

  ngOnInit() {

    if (this.gradientColors.length > 0) {
      //give colors to the slider icons
      this.startIconColor = this.gradientColors[0];
      this.endIconColor = this.gradientColors[this.gradientColors.length - 1];
    }
  }

  ngOnChanges() {
    this.allowDrag = this.allowDrag ?? true;

    if (this.value === null || this.value === undefined) {
      this.value = this.minValue;
    }

    if (this.unit === null || this.unit === undefined) {
      this.unit = "";
    }

    this._currentValue = this.value;
    this.progressValue = StaticClass.formatDecimalValue(this.value.toString(), 1, true);
  }

  /**
   * Get slider value when user drags slider and emit the value
   * @param event event received from DOM
   */
  public onIonChangeEmitValue(event: Event): void {
    const value: number = (event as CustomEvent).detail.value;

    this._currentValue = parseFloat(StaticClass.formatDecimalValue(value.toString(), 1, false));
    this.progressValue = StaticClass.formatDecimalValue(value.toString(), 1, true);

    this.onSliderValueChanged.emit(this._currentValue);
    this.onSliderChangeColor.emit(value);
  }

  /**
   * Set style for slider active part
   * @returns linear gradient expression for styling
   */
  public setStyleActivePartSlider(): string {
    if (this.lighterColor && this.darkerColor) {
      return `linear-gradient(90deg, ${this.lighterColor}, ${this.darkerColor})`;
    }
  }

  /**
   * Get linear gradient css expression for multiple colors
   * @returns linear gradient expression for styling
   */
  public setGradientMultipleColors(): string {
    if (this.gradientColors.length > 0) {
      let gradientExpression = 'linear-gradient(90deg, '

      gradientExpression += this.gradientColors.map((item, index) => {
        return `${item} ${Math.round(index * (100 / (this.gradientColors.length - 1)))}%`
      }).join(", ");

      return gradientExpression += ')';
    }
  }
}
